
import swal from 'sweetalert';
import { FormActionType } from './FormActionType';

export enum AlertType {
    info = 'info',
    success = 'success',
    warning = 'warning',
    error = 'warning'
}

interface IAlert {
    info(title:string, message: string, onOkCallback: Function): void ;
    success(title:string, message: string, onOkCallback: Function): void;
    warning(title:string, message: string, onOkCallback: Function): void;
    error(title:string, message: string, onOkCallback: Function): void
}

export class  UIMessage  {
    modal : IAlert = new UIModal();
    toast : IAlert = new UIToast();    

    confirm(title: string, message: string, type: AlertType, okButtonTitle: string,
        cancelButtonTitle: string, onOkCallback: Function, isDangerMode: boolean)
    {
        swal(title, message, type, { buttons: [cancelButtonTitle, okButtonTitle ] , dangerMode: isDangerMode})
        .then((value) => {
            if (value){
                if (onOkCallback){
                    onOkCallback();
                }
            }
        });        
    }    

    yesOrNo(title: string, message: string, yesButtonTitle: string, noButtonTitle: string, onYesCallback: Function, onNoCallback: Function)
    {
        swal(title, message, AlertType.info, 
            { 
                buttons: [noButtonTitle, yesButtonTitle],
                dangerMode: false,
                closeOnClickOutside: true
            })
            .then((value) => {
                if (value){
                    if (onYesCallback){
                        onYesCallback();
                    }
                }
                else {
                    if (onNoCallback){
                        onNoCallback();
                    }
                }
            });
    }
}


 class UIModal implements IAlert {
    info(title: string, message: string, onOkCallback: Function = null): void {
        this.setMesage(title,message, 'info', onOkCallback);

        
        
    }
    success(title: string, message: string, onOkCallback: Function = null): void {
        this.setMesage(title,message, 'success', onOkCallback);
    }
    warning(title: string, message: string, onOkCallback: Function = null): void {
        this.setMesage(title,message, 'warning', onOkCallback);
    }
    error(title: string, message: string, onOkCallback: Function = null): void {
        this.setMesage(title,message, 'error', onOkCallback);
    }

    private setMesage(title:string, message:string, type:string, onOkCallback: Function): void{
        swal(title,message,type)
            .then((value) => {
                if (onOkCallback){
                    onOkCallback();
                }
            });
    }
}

 class UIToast implements IAlert {
    info(title: string, message: string, onOkCallback: Function = null): void {
        //alert("selam ben bir UI tostum");
    }
    success(title: string, message: string, onOkCallback: Function = null): void {
        throw new Error("Method not implemented.");
    }
    warning(title: string, message: string, onOkCallback: Function = null): void {
        throw new Error("Method not implemented.");
    }
    error(title: string, message: string, onOkCallback: Function = null): void {
        throw new Error("Method not implemented.");
    }

}